// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import jardent from "assets/images/logos/gray-logos/logo.png";

// Constants
import CONSTANTS from "constants.js/constants";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "¿Aún no nos sigues en redes sociales?",
    image: jardent,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: CONSTANTS.URL_FACEBOOK,
    },
    {
      icon: <InstagramIcon />,
      link: CONSTANTS.URL_INSTAGRAM,
    },
    {
      icon: <WhatsAppIcon />,
      link: CONSTANTS.URL_WHATSAPP,
    },
  ],
  menus: [
    {
      name: "Navegación",
      items: [
        { name: "Inicio", route: "/index" },
        { name: "Acerca de Nosotros", route: "/acerca-de-nosotros" },
        { name: "Especialidades", route: "/especialidades" },
        { name: "Contacto", route: "/contacto" },
      ],
    },
    {
      name: "Recursos",
      items: [
        { name: "Casos de Éxito", route: "/casos-de-exito" },
        { name: "Promociones", route: "/promociones" },
        { name: "Danos tu opinión", route: "/opinion" },
        { name: "Visítanos en el mapa", href: CONSTANTS.URL_MAPS_LOCATION },
      ],
    },
    {
      name: "Legal",
      items: [{ name: "Aviso de Privacidad", route: "/aviso-de-privacidad" }],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Todos los derechos reservados. Copyright &copy; {date}.
    </MKTypography>
  ),
};
